/**
 * Download dos arquivos de som (F45, compartilhado com os leitos de ambiente da F46): o `fetch`
 * injetável, a conferência dos bytes mágicos (o fallback de SPA devolve o index.html com 200) e o
 * limite de tarefas ao mesmo tempo.
 */

export type SampleFormat = "webm" | "mp3";

export type Fetch = (url: string, init: { signal: AbortSignal }) => Promise<Pick<Response, "ok" | "status" | "arrayBuffer">>;

/** Formato pelos bytes mágicos: EBML (WebM) ou ID3 / sincronia de quadro (MP3). */
export function sniff(bytes: ArrayBuffer): SampleFormat | undefined {
  const b = new Uint8Array(bytes, 0, Math.min(4, bytes.byteLength));
  if (b.length === 4 && b[0] === 0x1a && b[1] === 0x45 && b[2] === 0xdf && b[3] === 0xa3) return "webm";
  if (b.length >= 3 && b[0] === 0x49 && b[1] === 0x44 && b[2] === 0x33) return "mp3";
  if (b.length >= 2 && b[0] === 0xff && (b[1]! & 0xe0) === 0xe0) return "mp3";
  return undefined;
}

/** No máximo `n` tarefas ao mesmo tempo; as outras esperam na ordem em que chegaram. */
export function limiter(n: number): <T>(task: () => Promise<T>) => Promise<T> {
  let active = 0;
  const waiting: (() => void)[] = [];
  return (task) =>
    new Promise((resolve, reject) => {
      const start = () => {
        active++;
        task()
          .then(resolve, reject)
          .finally(() => {
            active--;
            waiting.shift()?.();
          });
      };
      if (active < n) start();
      else waiting.push(start);
    });
}
